module.exports = __webpack_public_path__ + "img/bonus_phone_en.907a0006.png";